export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10811.0316bd1b.jpg";